import {reloadAxios} from "./api/Axios";

export default class LocalRepository {
    static isLogin() {
        return this.getUser() != null
    }

    static getUser() {
        const u = localStorage.getItem("user")

        try {
            if (u) return JSON.parse(u)
            else return null
        }
        catch (e) {
            return null
        }
    }

    static login(user) {
        localStorage.setItem("user", JSON.stringify(user))
        reloadAxios()
    }

    static logout() {
        localStorage.removeItem("user")
        reloadAxios()
    }

    static setFirebaseToken(token) {
        localStorage.setItem("firebase_token", token)
    }

    static getFirebaseToken() {
        return localStorage.getItem("firebase_token")
    }
}